import { Input, Row } from 'antd';
import React, { memo } from 'react';

import DefaultFormItem from 'components/composites/DefaultFormItem';
import BackOfficeEnterpriseSelect from 'components/forms/BackOfficeEnterpriseSelect/BackOfficeEnterpriseSelect';
import BackOfficeSiteSelect from 'components/forms/BackOfficeSiteSelect/BackOfficeSiteSelect';
import FormItemCol from 'components/forms/FormItemCol';

function BarnOwlAttachFormItems(): JSX.Element {
  return (
    <>
      <Row gutter={24}>
        <BackOfficeEnterpriseSelect
          clearSiteOnChange
          placeholder="Search enterprise"
        />
      </Row>
      <Row gutter={24}>
        <BackOfficeSiteSelect filterByEnterprise placeholder="Select site" />
        <FormItemCol>
          <DefaultFormItem
            name="cameraName"
            label="Camera name"
            rules={[{ required: true, message: 'Please enter a camera name' }]}
          >
            <Input placeholder="Camera display name" />
          </DefaultFormItem>
        </FormItemCol>
      </Row>
      <Row gutter={24}>
        <FormItemCol>
          <DefaultFormItem
            name="IMEI"
            label="IMEI"
            rules={[{ required: true, message: 'Please enter the camera IMEI' }]}
          >
            <Input placeholder="IMEI" />
          </DefaultFormItem>
        </FormItemCol>
        <FormItemCol>
          <DefaultFormItem
            name="ICCID"
            label="ICCID"
            rules={[{ required: true, message: 'Please enter the SIM ICCID' }]}
          >
            <Input placeholder="ICCID" />
          </DefaultFormItem>
        </FormItemCol>
      </Row>
    </>
  );
}

export default memo(BarnOwlAttachFormItems);
